import { get } from 'lodash';
import { get as fpGet, flow } from 'lodash/fp';

import {
  STYLING_KEY_BUTTON,
  STYLING_KEY_PAGE,
  STYLING_KEY_OPTION_TEXT,
  STYLING_KEY_QUESTION_TEXT,
  STYLING_KEY_STATIC_TEXT,
  STYLING_KEY_BODY,
  STYLING_KEY_BLOCK,
} from 'sharedParts';

import {
  BACKGROUND_COLOR_KEY,
  BACKGROUND_IMAGE_KEY,
  BACKGROUND_POSITION_KEY,
  BORDER_COLOR_KEY,
  BORDER_RADIUS_KEY,
  BORDER_STYLE_KEY,
  BORDER_WIDTH_KEY,
  FONT_COLOR_KEY,
  FONT_FAMILY_KEY,
  FONT_SIZE_KEY,
  FONT_STYLE_KEY,
  FONT_WEIGHT_KEY,
  STYLING_KEY_TEXTFIELD,
  STYLING_KEY_LABEL,
  SELECTION_COLOR_KEY,
  STICK_TO_KEY,
  TEXT_DECORATION_KEY,
  TEXT_TRANSFORM_KEY,
  MARGIN_KEY,
} from '../const/StylingSettingKeys';

export const getStaticTextStyles = state => get(state, STYLING_KEY_STATIC_TEXT);
export const getQuestionTextStyles = state =>
  get(state, STYLING_KEY_QUESTION_TEXT);
export const getOptionTextStyles = state => get(state, STYLING_KEY_OPTION_TEXT);
export const getButtonStyles = state => get(state, STYLING_KEY_BUTTON);
export const getPageStyles = state => get(state, STYLING_KEY_PAGE);
export const getBodyStyles = state => get(state, STYLING_KEY_BODY);
export const getBlockStyles = state => get(state, STYLING_KEY_BLOCK);

const getBackgroundColor = fpGet(BACKGROUND_COLOR_KEY);
const getBorderColor = fpGet(BORDER_COLOR_KEY);
const getBorderRadius = fpGet(BORDER_RADIUS_KEY);
const getBorderStyle = fpGet(BORDER_STYLE_KEY);
const getBorderWidth = fpGet(BORDER_WIDTH_KEY);
const getFontColor = fpGet(FONT_COLOR_KEY);
const getFontSize = fpGet(FONT_SIZE_KEY);
const getFontStyle = fpGet(FONT_STYLE_KEY);
const getFontWeight = fpGet(FONT_WEIGHT_KEY);
const getLabel = fpGet(STYLING_KEY_LABEL);
const getOptionText = fpGet(STYLING_KEY_OPTION_TEXT);
const getQuestionText = fpGet(STYLING_KEY_QUESTION_TEXT);
const getStaticText = fpGet(STYLING_KEY_STATIC_TEXT);
const getStickTo = fpGet(STICK_TO_KEY);
const getTextDecoration = fpGet(TEXT_DECORATION_KEY);
const getTextfield = fpGet(STYLING_KEY_TEXTFIELD);
const getTextTransform = fpGet(TEXT_TRANSFORM_KEY);

export const getTextfieldBackgroundColor = flow(
  getTextfield,
  getBackgroundColor,
);
export const getTextfieldBorderColor = flow(
  getTextfield,
  getBorderColor,
);
export const getTextfieldBorderRadius = flow(
  getTextfield,
  getBorderRadius,
);
export const getTextfieldBorderStyle = flow(
  getTextfield,
  getBorderStyle,
);
export const getTextfieldBorderWidth = flow(
  getTextfield,
  getBorderWidth,
);
export const getTextfieldFontColor = flow(
  getTextfield,
  getFontColor,
);
export const getTextfieldFontSize = flow(
  getTextfield,
  getFontSize,
);
export const getTextfieldFontStyle = flow(
  getTextfield,
  getFontStyle,
);
export const getTextfieldFontWeight = flow(
  getTextfield,
  getFontWeight,
);
export const getTextfieldTextDecoration = flow(
  getTextfield,
  getTextDecoration,
);
export const getTextfieldTextTransform = flow(
  getTextfield,
  getTextTransform,
);
export const getLabelFontColor = flow(
  getLabel,
  getFontColor,
);
export const getLabelFontSize = flow(
  getLabel,
  getFontSize,
);
export const getLabelFontStyle = flow(
  getLabel,
  getFontStyle,
);
export const getLabelFontWeight = flow(
  getLabel,
  getFontWeight,
);
export const getLabelStickTo = flow(
  getLabel,
  getStickTo,
);
export const getLabelTextDecoration = flow(
  getLabel,
  getTextDecoration,
);
export const getLabelTextTransform = flow(
  getLabel,
  getTextTransform,
);
export const getSelectionColor = fpGet(SELECTION_COLOR_KEY);
export const getStaticTextFontSize = state =>
  get(getStaticTextStyles(state), FONT_SIZE_KEY);

export const getStaticTextFontFamily = state =>
  get(getStaticTextStyles(state), FONT_FAMILY_KEY);

export const getStaticTextFontColor = state =>
  get(getStaticTextStyles(state), FONT_COLOR_KEY);
export const getStaticTextFontStyle = flow(
  getStaticText,
  getFontStyle,
);
export const getStaticTextFontWeight = flow(
  getStaticText,
  getFontWeight,
);
export const getStaticTextDecoration = flow(
  getStaticText,
  getTextDecoration,
);
export const getStaticTextTransform = flow(
  getStaticText,
  getTextTransform,
);
export const getQuestionTextFontSize = state =>
  get(getQuestionTextStyles(state), FONT_SIZE_KEY);

export const getQuestionTextFontFamily = state =>
  get(getQuestionTextStyles(state), FONT_FAMILY_KEY);

export const getQuestionTextFontColor = state =>
  get(getQuestionTextStyles(state), FONT_COLOR_KEY);
export const getQuestionTextFontStyle = flow(
  getQuestionText,
  getFontStyle,
);
export const getQuestionTextFontWeight = flow(
  getQuestionText,
  getFontWeight,
);
export const getQuestionTextDecoration = flow(
  getQuestionText,
  getTextDecoration,
);
export const getQuestionTextTransform = flow(
  getQuestionText,
  getTextTransform,
);
export const getOptionTextFontSize = state =>
  get(getOptionTextStyles(state), FONT_SIZE_KEY);

export const getOptionTextFontFamily = state =>
  get(getOptionTextStyles(state), FONT_FAMILY_KEY);

export const getOptionTextFontColor = state =>
  get(getOptionTextStyles(state), FONT_COLOR_KEY);
export const getOptionTextFontStyle = flow(
  getOptionText,
  getFontStyle,
);
export const getOptionTextFontWeight = flow(
  getOptionText,
  getFontWeight,
);
export const getOptionTextDecoration = flow(
  getOptionText,
  getTextDecoration,
);
export const getOptionTextTransform = flow(
  getOptionText,
  getTextTransform,
);
export const getButtonFontSize = state =>
  get(getButtonStyles(state), FONT_SIZE_KEY);

export const getButtonFontColor = state =>
  get(getButtonStyles(state), FONT_COLOR_KEY);

export const getButtonFontWeight = state =>
  get(getButtonStyles(state), FONT_WEIGHT_KEY);

export const getButtonFontStyle = state =>
  get(getButtonStyles(state), FONT_STYLE_KEY);

export const getButtonTextDecoration = state =>
  get(getButtonStyles(state), TEXT_DECORATION_KEY);

export const getButtonTextTransform = state =>
  get(getButtonStyles(state), TEXT_TRANSFORM_KEY);

export const getButtonBorderWidth = state =>
  get(getButtonStyles(state), BORDER_WIDTH_KEY);

export const getButtonBorderStyle = state =>
  get(getButtonStyles(state), BORDER_STYLE_KEY);

export const getButtonBorderRadius = state =>
  get(getButtonStyles(state), BORDER_RADIUS_KEY);

export const getButtonBorderColor = state =>
  get(getButtonStyles(state), BORDER_COLOR_KEY);

export const getButtonBackgroundColor = state =>
  get(getButtonStyles(state), BACKGROUND_COLOR_KEY);

export const getPageBackgroundColor = state =>
  get(getPageStyles(state), BACKGROUND_COLOR_KEY);

export const getBodyBackgroundColor = state =>
  get(getBodyStyles(state), BACKGROUND_COLOR_KEY);

export const getBodyBackgroundImage = state =>
  get(getBodyStyles(state), BACKGROUND_IMAGE_KEY);

export const getBodyBackgroundPosition = state =>
  get(getBodyStyles(state), BACKGROUND_POSITION_KEY);

export const getBlockMargin = state => get(getBlockStyles(state), MARGIN_KEY);
